import CollectionLabel from './CollectionLabel';

export default CollectionLabel;
export * from './CollectionLabel';
